import createMouseFollow from '../anims/MouseFollow'

export default class MouseFollow {
  constructor() {
    this._getElems()
    this._mouseFollow()
  }

  _getElems() {
    this.elements = Array.from(document.querySelectorAll('[data-mouse-follow]')).map((container) => ({
      els: Array.from(container.querySelectorAll('[data-mouse-follow-el]')).map((el) => {
        const forceModifier = el.dataset.forceModifier ?? container.dataset.forceModifier ?? 0.4

        return {
          el,
          forceModifier
        }
      }),
      container
    }))
  }

  _mouseFollow() {
    if (this.elements) {
      this.elements.forEach(({els, container}) => {
        createMouseFollow({
          els,
          container
        })
      })
    }
  }
}
